// EmailJS settings for the contact form. The values live in the .env file at the project root.
// See "Contact form setup" in README.md.
export const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
export const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
export const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
